// Splits a `---\nkey: value\n---\nbody` markdown file into { data, content }.
// The help articles only ever use flat, unquoted key: value pairs, so a
// full YAML parser would be overkill here.
export function parseFrontmatter(raw) {
  const match = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/);
  if (!match) return { data: {}, content: raw };

  const [, frontmatter, content] = match;
  const data = {};
  frontmatter.split('\n').forEach(line => {
    const idx = line.indexOf(':');
    if (idx === -1) return;
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim();
    if (key) data[key] = value;
  });

  return { data, content };
}

// Every article's body opens with a `# Title` line that duplicates the
// frontmatter title (which callers render separately as the page heading).
// Strip it so the title doesn't appear twice.
export function stripLeadingTitle(content) {
  return content.replace(/^\s*#\s+.+\n+/, '');
}
